import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../static/css/AdminLogin.css";

function AdminLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [ischecked, setIsChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handlesubmit = async (e) => {
    e.preventDefault();

    const loginData = { emailid: email, password };

    try {
      const response = await fetch("https://backend.skpandco.in/users/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(loginData),
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Login successful:", data);
        navigate("/admincontrol");
      } else {
        const errorText = await response.text();
        setErrorMessage(errorText);
      }
    } catch (error) {
      console.error("Error logging in:", error);
      setErrorMessage("An error occurred while logging in.");
    }
  };

  return (
    <>
      <div className="AdminLogin-container">
        <div className="AdminLogin-box">
          <h3>Admin Login</h3>
          <form onSubmit={handlesubmit}>
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label htmlFor="password">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="checkbox-container">
              <input
                type="checkbox"
                checked={ischecked}
                onChange={(e) => {
                  setIsChecked(e.target.checked);
                }}
              />
              <label htmlFor="checkbox">Remember me</label>
            </div>
            <button type="submit">Login</button>
          </form>
          {errorMessage && <p className="error-message">{errorMessage}</p>}{" "}
        </div>
      </div>
    </>
  );
}

export default AdminLogin;
